export const fixedAssetsCategories = `{
     allFixedAssetCategories {
        id
        companyId
        categoryName
        description
        createdAt
        createdBy
        updatedAt
        updatedBy
        isActive
    }
}`;

export const allAssetTypes = `{
     allAssetTypes {
        id
        companyId
        categoryId
        typeName
        description
        createdAt
        createdBy
        updatedAt
        updatedBy
        isActive
    }
}`;

export const allDepreciationMethods = `{
    allDepreciationMethods {
        id
        methodName
        description
        createdBy
        updatedDate
        updatedBy
        isActive
    }
}`;

export const allDepreciationSchedules = `{
    allDepreciationSchedules {
              id
        companyId
        categoryId
        categoryName
        categoryDescription
        typeId
        assetTypeName
        assetTypeDescription
        methodId
        depreciationMethodName
        methodDescription
        usefulLifeYears
        salvageValue
        totalEstimatedUnits
        isActive
        createdAt
        updatedAt
        createdBy
        updatedBy
    }
}`;

export const allFixedAssets = `{
    allFixedAssets {
        id
        companyId
        categoryId
        typeId
        scheduleId
        methodId
        assetCode
        assetName
        description
        serialNumber
        purchaseDate
        purchaseCost
        currentValue
        location
        department
        custodian
        acquisitionDate
        disposalDate
        disposalValue
        disposalReason
        status
        createdAt
        createdBy
        updatedAt
        updatedBy
        isActive
    }
}`;